module.exports = __webpack_public_path__ + "static/media/image-card-7.aab99ea8.png";